import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable, ReplaySubject, switchMap, tap } from "rxjs";
import { IKryptomonResponse, IKryptomonSubgraph, IKryptomonSubgraphQueryRes, Ikryptomon } from "./kryptomons.interface";
import { Web3Service } from "../web3/web3.service";
import { subgraphChainName } from "app/common/utils/subgraph.utils";
import { eNetworkName } from "../contract/contract.config";
import { kryptomonExtraInfoQuery } from "./kryptomons.subgraph.query";
import { enrichDataForKryptomon, parseFromNFTtoKryptomon } from "./kryptomons.utilities";
import { getCookieValue } from "app/common/utils/cookie.util";
import { IAnyKryptomonFilter, IAnyKryptomonResponse } from "./kryptomons-any-nft.interface";

@Injectable({
    providedIn: 'root'
})
export class KryptomonsService {
    private _kryptomons: ReplaySubject<Ikryptomon[]> = new ReplaySubject<Ikryptomon[]>(1);
    // private _kryptomonsSyntetic: ReplaySubject<Ikryptomon[]> = new ReplaySubject<Ikryptomon[]>(1);
    private _kryptomonDetail: ReplaySubject<Ikryptomon> = new ReplaySubject<Ikryptomon>(1);
    // private _kryptomonsSynteticDetail: ReplaySubject<Ikryptomon> = new ReplaySubject<Ikryptomon>(1);
    private _anyKryptomons: ReplaySubject<Ikryptomon[]> = new ReplaySubject<Ikryptomon[]>(1);

    constructor(
        private http: HttpClient,
        private web3Service: Web3Service
    ) { }

    // getAll(walletAddress: string, offset: number = 0, limit: number = 1000): Observable<any> {
    //     return this.http.get<IKryptomonResponse[]>(`${environment.apiBaseUrlV22}user/${walletAddress}/kryptomons/detail?offset=${offset}&limit=${limit}`
    //     ).pipe(tap(k => this._kryptomons.next(k)));
    // }

    getAll(walletAddress: string, offset: number = 0, limit: number = 1000): Observable<IKryptomonResponse[]> {
        var kryptomonRes: IKryptomonResponse[];
        var tokenIds: string[]
        return this.http.get<IKryptomonResponse[]>(`${environment.apiBaseUrlV22}user/${walletAddress}/kryptomons/detail?offset=${offset}&limit=${limit}`
        ).pipe(tap(k => {
            tokenIds = k.map(k1 => k1.tokenId);
            kryptomonRes = k;
            this.getExtraInfoSubgraph(tokenIds).subscribe(
                sk => {//response subgraph api call
                    if (!sk.errors) {
                        let allInfoKryptomon: Ikryptomon[] = [];
                        let synteticKryptomons: Ikryptomon[] = kryptomonRes.filter(kr => kr.isStarter);
                        kryptomonRes.filter(kr => !kr.isStarter).forEach(k2 => {
                            allInfoKryptomon.push({
                                ...k2,
                                extraMarketData: sk.data.kryptomons.filter(sk1 => sk1.tokenId == k2.tokenId)[0],
                                orders: sk.data.orders.filter(sk1 => sk1.tokenId == k2.tokenId),
                                bids: sk.data.bids.filter(sk1 => sk1.tokenId == k2.tokenId)
                            });
                            //add breeding price in float
                            allInfoKryptomon.forEach(k => { if (k.extraMarketData?.breedingOrder) k.extraMarketData.breedingOrder.priceFloat = this.getPriceFloat(k.extraMarketData) });
                        });
                        synteticKryptomons.forEach(sk => allInfoKryptomon.push(sk));
                        this._kryptomons.next(allInfoKryptomon);
                        // this._kryptomonsSyntetic.next(synteticKryptomons);
                    } else {
                        console.error('error in subgraph query');
                        this._kryptomons.next(kryptomonRes)
                    }
                }
            )
        }));
    }

    getDetail(tokenId: string): Observable<IKryptomonResponse> {
        var kryptomonDetailRes: IKryptomonResponse;
        return this.http.get<IKryptomonResponse>(`${environment.apiBaseUrlV22}kryptomon/${tokenId}`).pipe(tap(k => {
            kryptomonDetailRes = k;
            if (!kryptomonDetailRes.isStarter) {
                this.getExtraInfoSubgraph([tokenId]).subscribe(
                    sk => {
                        if (!sk.errors) {
                            let enrichedKryptomon: Ikryptomon = {
                                ...kryptomonDetailRes,
                                extraMarketData: sk.data.kryptomons[0],
                                orders: sk.data.orders,
                                bids: sk.data.bids
                            };
                            enrichedKryptomon = enrichDataForKryptomon(enrichedKryptomon);
                            //add breeding price in float
                            if (enrichedKryptomon.extraMarketData?.breedingOrder) enrichedKryptomon.extraMarketData.breedingOrder.priceFloat = this.getPriceFloat(enrichedKryptomon.extraMarketData);
                            this._kryptomonDetail.next(enrichedKryptomon);
                        } else {
                            console.error('error in subgraph query');
                            this._kryptomonDetail.next(kryptomonDetailRes);
                        }
                    }
                );
            } else {
                kryptomonDetailRes = enrichDataForKryptomon(kryptomonDetailRes);
                this._kryptomonDetail.next(kryptomonDetailRes);
                // this._kryptomonsSynteticDetail.next(kryptomonDetailRes);
            }
        }));
    }

    getExtraInfoSubgraph(tokenIds: string[]): Observable<IKryptomonSubgraphQueryRes> {
        let query: string = kryptomonExtraInfoQuery(tokenIds);
        let chainNameForSubgraph: string = subgraphChainName(this.web3Service.getNetworkName() as eNetworkName);
        return this.http.post<IKryptomonSubgraphQueryRes>(`${environment.subgraph + chainNameForSubgraph}/api`,
            { query })
    }


    get kryptomons$(): Observable<Ikryptomon[]> {
        return this._kryptomons.asObservable();
    }

    get kryptomonDetail$(): Observable<Ikryptomon> {
        return this._kryptomonDetail.asObservable();
    }

    // get kryptomonsSyntetic$(): Observable<Ikryptomon[]> {
    //     return this._kryptomonsSyntetic.asObservable();
    // }

    // get kryptomonSytnteticDetail$(): Observable<Ikryptomon> {
    //     return this._kryptomonsSynteticDetail.asObservable();
    // }

    getPriceFloat(extraMarketData: IKryptomonSubgraph): number {
        let result: number;
        if (extraMarketData && extraMarketData.breedingOrder) {
            result = extraMarketData.breedingOrder.price ?
                this.web3Service.fromWeiFloat(extraMarketData.breedingOrder.price) :
                undefined
        }
        return result;
    }

    updateKryptomonName(tokenId: string, newName: string, signature: string, enable: boolean = true): Observable<any> {
        let post = {
            id: tokenId,
            name: newName,
            network: this.web3Service.getNetworkName(),
            signature: signature,
            enable: true
        }
        return this.http.post(environment.apiBaseUrlV22 + "kryptomons-meta/" + tokenId + "/name", post);
    }

    destroyKryptomonSyntetic(ownerWallet: string, signature: string, tokenId: string): Observable<any> {
        let playfabToken: string = getCookieValue("playfab-entity-token");
        let body = { signature: signature, wallet: ownerWallet, entityToken: playfabToken, timestamp: Date.now() };
        return this.http.post(environment.apiBaseUrlV22 + 'kryptomon-starters/delete/' + tokenId, body);
    }

    evolveSyntetic(ownerWallet: string, signature: string, tokenId: string, status: number): Observable<any> {
        // let post = {
        //     tokenId: tokenId,
        //     walletId: ownerWallet,
        //     timestamp: Date.now(),
        //     status: status
        // }; 
        let post = {
            signature: signature,
            wallet: ownerWallet,
            timestamp: Date.now(),
            status: status
        };
        // return this.http.post(environment.apiBaseUrl + "f2p/evolveKryptomon.php", post);
        return this.http.post(environment.apiBaseUrlV22 + `kryptomon-starters/${tokenId}/evolve`, post);
    }

    get anyKryptomons$(): Observable<Ikryptomon[]> {
        return this._anyKryptomons.asObservable();
    }

    getAnyKryptomons(kryptomonFilter?: Partial<IAnyKryptomonFilter>, first: number = 100, skip: number = 0): Observable<IAnyKryptomonResponse> {
        let queryParam: HttpParams = new HttpParams();
        let standardQueryParam = {
            first: first,
            skip: skip,
            sortBy: 'newest',
            category: 'kryptomon'
        };
        queryParam = queryParam.appendAll(standardQueryParam);
        queryParam = queryParam.appendAll(kryptomonFilter)
        // for (const key in kryptomonFilter) {
        //     queryParam = queryParam.append(key, kryptomonFilter[key]);
        // }
        return this.http.get<IAnyKryptomonResponse>(environment.nftServer + 'v1/nfts', { params: queryParam }).pipe(
            tap(k => {
                let parsedKryptomon: Ikryptomon[] = parseFromNFTtoKryptomon(k);
                //add breeding price in float and in USD
                parsedKryptomon.forEach(k => {
                    if (k.extraMarketData?.breedingOrder) {
                        k.extraMarketData.breedingOrder.priceFloat = this.getPriceFloat(k.extraMarketData);
                    }
                });
                this._anyKryptomons.next(parsedKryptomon);
            })
        );
    }

}